import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Filter from '../Filter';

export default reduxForm({
  form: 'webOrderFilter',
})(connect(() => ({
}))((Filter)));
